import { FC } from 'react';
import { BaseSecuritiesModalProps } from '../BaseSecuritiesModal';
import { InfoWrapper, Modal, Text } from './styled';
import { SPLIT_ORDER_MODAL_CONTENT } from './constants';

interface InfoItem {
  title: string;
  description: string;
}

interface SplitOrderInfoModalProps extends BaseSecuritiesModalProps {
  description?: string;
  info?: InfoItem[];
}

const SplitOrderInfoModal: FC<SplitOrderInfoModalProps> = ({
  title = 'Split Order',
  description = 'Split your order into multiple smaller orders for better trading strategy management.',
  info = SPLIT_ORDER_MODAL_CONTENT.DEFAULT,
  ...props
}) => (
  <Modal title={title} hideSubmit {...props}>
    <Text>{description}</Text>

    {info.map((infoItem, idx) => (
      <InfoWrapper key={idx.toString()}>
        <Text weight="700">{infoItem.title}</Text>
        <Text>{infoItem.description}</Text>
      </InfoWrapper>
    ))}
  </Modal>
);

export default SplitOrderInfoModal;
